import httpService from '@/core/http-service'
import { filter } from 'lodash'

const state = {
  deliveryAddresses: null,
  currentDeliveryAddress: null,
  filter: ''
}

const mutations = {
  set_deliveryAddresses(state, payload) {
    state.deliveryAddresses = payload
  },
  set_current_delivery_address(state, payload) {
    state.currentDeliveryAddress = payload
  },
  set_filter(state, payload) {
    state.filter = payload
  }
}

const actions = {
  async getDeliveryAddresses({ commit }, payload) {
    const response = await httpService.get('auth/getshippingaddresses')
    commit('set_deliveryAddresses', response.data)
  },
  setCurrentDeliveryAddress({ commit }, payload) {
    commit('set_current_delivery_address', payload)
  },
  async updateDeliveryAddress({ commit }, payload) {
    const response = await httpService.post('auth/mydeliveryAddresses/update', payload)
    commit('set_deliveryAddresses', response.data.deliveryAddresses)
  },
  async deleteDeliveryAddress({ commit }, payload) {
    // todo: remove the address, this is triggered from the modal, triggered by deleteAddress below
    // 1. check if deleteAddress is a valid endpoint and add the correct data to it
    // 2. handle the removal of the address from the array (in some way)
    // 3. potentially close the dropdown with addresses (if not closed by outside click)

    if (payload !== undefined) {
      httpService.delete('auth/deleteAddress', { addressId: payload }).then((response) => {
        if (response.data.success) {
          commit('set_deliveryAddresses', response.data.addresses)
          this.addressDeleted = true
          this.defaultAddress = this.filteredDeliveryAddresses.find(a => { return a.isPreferredAddress })
        }
      })
    }
  },
  setFilter({ commit }, filter) {
    commit('set_filter', filter)
  }
}

const getters = {
  deliveryAddresses: state => state.deliveryAddresses,
  currentDeliveryAddress: state => state.currentDeliveryAddress,
  filter: state => state.filter,
  filteredDeliveryAddresses: state => {
    if (!state.filter) return state.deliveryAddresses

    return filter(state.deliveryAddresses, list => list.searchText.toLowerCase().includes(state.filter.toLowerCase()))
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
